import React from "react";
import { Alert, Button, Empty, Space, Typography } from "antd";

const { Paragraph, Text } = Typography;

interface AnalyticsSetupGuideProps {
  mode: "empty" | "waiting";
  installSnippet?: string;
  onCreate?: () => void;
}

const AnalyticsSetupGuide: React.FC<AnalyticsSetupGuideProps> = ({
  mode,
  installSnippet = "",
  onCreate,
}) => {
  if (mode === "empty") {
    return (
      <Empty description="还没有统计站点">
        <Space direction="vertical" size={12}>
          <Paragraph type="secondary" style={{ marginBottom: 0 }}>
            创建站点并在网页中安装统计代码后，这里会展示访问趋势、来源、页面与实时访客。
          </Paragraph>
          <Button type="primary" onClick={onCreate}>
            创建第一个站点
          </Button>
        </Space>
      </Empty>
    );
  }

  return (
    <Alert
      type="info"
      showIcon
      style={{ marginBottom: 16 }}
      message="尚未收到访问事件，请确认统计代码已安装"
      description={
        <Paragraph copyable={{ text: installSnippet }} style={{ marginBottom: 0 }}>
          <Text code>{installSnippet}</Text>
        </Paragraph>
      }
    />
  );
};

export default AnalyticsSetupGuide;
